<template>
  <span class="scaling-svg-container">
    <svg
      class="scaling-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="14.375"
      height="14.376"
      viewBox="0 0 14.375 14.376"
    >
      <path
        d="M13.577,14.376a.794.794,0,0,1-.565-.234L10.3,11.43a6.318,6.318,0,0,1-3.911,1.348,6.389,6.389,0,1,1,6.389-6.389A6.318,6.318,0,0,1,11.43,10.3l2.712,2.712a.8.8,0,0,1-.564,1.363ZM6.389,1.6a4.792,4.792,0,1,0,4.792,4.792A4.8,4.8,0,0,0,6.389,1.6Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class SearchIcon extends Vue {}
</script>

<style>
</style>
